<template>
  <div class="ranking">
    <header class="card-header">
      <p class="card-header-title">
        Top 100 Items Compared
      </p>
    </header>
    <div class="card-content">
      <Top10Chart
        class="content-body"
        :top10Data="chartData.data"
      />
    </div>
  </div>
</template>

<script>
import Top10Chart from './Top10Chart'

export default {
  components: {
    Top10Chart
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.ranking {
  height: 100%;

  .card-header-title {
    padding-left: 20px;
    font-weight: 400;
    font-size: 16px;
  }

  .coming-soon {
    padding-top: 55px;
    color: $primary;
    font-weight: 700;
    font-size: 40px;
    text-align: center;
  }

  .card-content {
    height: 230px;
    padding: 4px;
    overflow-y: auto;
  }
}
</style>
